import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'gb-back-button',
  templateUrl: './gb-back-button.component.html',
  styleUrls: ['./gb-back-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GbBackButtonComponent {
  @Input() labelTranslateKey = 'BACK'
}
